import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PendingRequestsService {
  private _pendingCount = signal(0);

  hasPendingRequests = computed(() => this._pendingCount() > 0);

  increment() {
    this._pendingCount.update((c) => c + 1);
  }

  decrement() {
    this._pendingCount.update((c) => Math.max(0, c - 1));
  }
}
